//所有页面react根元素
import React,{Component} from 'react';

import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import ComponentMap from './ComponentMap'

 

class Main extends Component{
    constructor(props) {
        super(props);
        this.id = this.props.id;

    }
    render(){
    	return (
    		<div ref={ref=> this.div=ref} id={this.id} style={this.props.style}>
    			{this.props.children}
    		</div>
    	)
    }

    componentDidMount() {
        ComponentMap.put(this.id,this);
        //console.log("挂载完毕",ComponentMap.map);
        //平台react元素加载完毕事件
        if (this.props["self-Adaption"]) {
        	let div = this.div;
        	div.parentElement.style.height="100%";
        	div.parentElement.parentElement.style.height="100%";
        }
        if (this.props.reactOnLoad) {
        	this.props.reactOnLoad();
        }
    }
}
export default Main


// WEBPACK FOOTER //
// ./component/Main.js